import React from 'react';
import { Modal } from 'antd';

const SummaryDialog = ({ visible, rowCount, onConfirm, onCancel }: any) => (
  <Modal
    open={visible}
    onOk={onConfirm}
    onCancel={onCancel}
    okText="Save Valid Rows"
    cancelText="Cancel"
  >
    <p>You are about to upload <b>{rowCount}</b> valid rows. Continue?</p>
  </Modal>
);

export default SummaryDialog;
